import classNames from "classnames";
import "./index.scss";

interface IProps {
  bgColor?: string;
  arrowColor?: string;
  isClicked: boolean;
  onClick: () => void;
}

export const AccordionDropDownIcon = ({
  bgColor,
  arrowColor,
  isClicked,
  onClick,
}: IProps) => {
  return (
    <div onClick={onClick} className={classNames({ "accordion-item-rotate": isClicked })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="59"
        height="59"
        viewBox="0 0 59 59"
        fill="none"
      >
        <g filter="url(#filter0_d_14915_421120)">
          <rect
            x="4"
            width="51"
            height="51"
            rx="5"
            fill={bgColor ? bgColor : "#273E5A"}
          />
        </g>
        <path
          d="M38.4209 27.3808L27.2295 38.4274C26.456 39.1909 25.2052 39.1909 24.4399 38.4274L22.5801 36.5917C21.8066 35.8282 21.8066 34.5936 22.5801 33.8382L30.5129 26.0081L22.5801 18.1781C21.8066 17.4146 21.8066 16.1799 22.5801 15.4246L24.4317 13.5726C25.2052 12.8091 26.456 12.8091 27.2213 13.5726L38.4127 24.6192C39.1944 25.3827 39.1944 26.6173 38.4209 27.3808Z"
          fill={arrowColor ? arrowColor : "white"}
        />
        <defs>
          <filter
            id="filter0_d_14915_421120"
            x="0"
            y="0"
            width="59"
            height="59"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_14915_421120"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_14915_421120"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};
